import { render, staticRenderFns } from "./IntroLessonShowcaseDialog.vue?vue&type=template&id=2b7fc1a8&scoped=true&"
import script from "./IntroLessonShowcaseDialog.vue?vue&type=script&lang=ts&"
export * from "./IntroLessonShowcaseDialog.vue?vue&type=script&lang=ts&"
import style0 from "./IntroLessonShowcaseDialog.vue?vue&type=style&index=0&id=2b7fc1a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7fc1a8",
  null
  
)

export default component.exports